




















import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class ModalKonfirmasi extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() msg!: object;
  // hidden = true
  nextDialog = false;

  get dialog() {
    return this.value;
  }
  set dialog(value) {
    this.$emit("input", value);
  }
  nextStep() {
    this.dialog = false;
    this.$emit("nextDialog", this.nextDialog);
  }
  // @Watch('err')
  // change(value: object, oldValue: object) {
  //     // this.dtDokter = value
  //     // this.listDokter = this.listDokterUnit
  //     this.err=value
  //     // console.log(value)

  //     // this.changeDokter()
  // }
}
